import moment from "moment";

export const getFormattedDate = (date) => {
  const formattedDate =
    // moment(date).format("ddd") +
    // " " +
    moment(date).format("MMM") +
    " " +
    moment(date).format("DD") +
    " " +
    moment(date).format("YYYY");

  return formattedDate;
};

export const getYYYYMMDDFormattedDate = (date) => {
  const formattedDate =
    // moment(date).format("ddd") +
    // " " +
    moment(date).format("YYYY") +
    "-" +
    moment(date).format("MM") +
    "-" +
    moment(date).format("DD");
  return formattedDate;
};

export const getYYYYMMDDFormattedDateWithAddedDays = (date, days) => {
  let finalDate = moment(date).add(days, "days");
  const formattedDate =
    // moment(date).format("ddd") +
    // " " +
    moment(finalDate).format("YYYY") +
    "-" +
    moment(finalDate).format("MM") +
    "-" +
    moment(finalDate).format("DD");
  return formattedDate;
};
